/**
 * FAQ
 */
import faqPage from '../lib/faq-page';

faqPage();
